import React, { Component } from "react";
import "../Styles/SvgCommand.css";

class AddCommand extends Component {
  state = { canShowForm: false };
  addCommandClickHandler = () => {
    this.setState((prevState) => {
      return { canShowForm: !prevState.canShowForm };
    });
  };
  render() {
    const detailForm = this.props.detailForm;
    return (
      <div onClick={this.addCommandClickHandler}>
        <svg className={"svg" + " " + this.props.className}>
          <rect x="5" y="9" width="16" height="1.5" rx="1" />
          <rect x="12" y="2" width="1.5" height="16" rx="1" />
        </svg>
        {this.state.canShowForm && detailForm}
      </div>
    );
  }
}

export default AddCommand;
